var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19526 4.19526C4.45561 3.93491 4.87772 3.93491 5.13807 4.19526L12 11.0572L18.8619 4.19526C19.1223 3.93491 19.5444 3.93491 19.8047 4.19526C20.0651 4.45561 20.0651 4.87772 19.8047 5.13807L12.9428 12L19.8047 18.8619C20.0651 19.1223 20.0651 19.5444 19.8047 19.8047C19.5444 20.0651 19.1223 20.0651 18.8619 19.8047L12 12.9428L5.13807 19.8047C4.87772 20.0651 4.45561 20.0651 4.19526 19.8047C3.93491 19.5444 3.93491 19.1223 4.19526 18.8619L11.0572 12L4.19526 5.13807C3.93491 4.87772 3.93491 4.45561 4.19526 4.19526Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingClose);
export default __webpack_public_path__ + "static/media/onboarding-close.b751a874fd7b9068c14422a80dc6e558.svg";
export { ForwardRef as ReactComponent };